import DOMPurify from 'dompurify';

/**
 * II1-E9-S1: map-popup content is built server-side from data (depot names,
 * addresses, station labels) that isn't guaranteed to be free of HTML, so it
 * is rendered via dangerouslySetInnerHTML without ever having been through a
 * template/escaping layer. Sanitise before render so injected markup can't
 * execute in the browser.
 *
 * DOMPurify silently returns its input unmodified (no error) if it can't
 * find the DOM APIs it needs (DOMPurify.isSupported) -- happy-dom in this
 * repo's test environment is one such case. Refusing to render rather than
 * rendering unsanitised is the safe failure mode here.
 */
export function sanitizeMapPopupHtml(html: string): string {
  if (!DOMPurify.isSupported) {
    throw new Error('DOMPurify is not supported in this environment -- refusing to render unsanitised HTML');
  }
  return DOMPurify.sanitize(html);
}
